var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "screen-mode-and-save justify-content-end",
          class: { "screen-mode-and-save-scroll": _vm.isScroll }
        },
        [
          _c("div", { staticClass: "wrap-screen-mode justify-content-end" }, [
            _c(
              "button",
              { staticClass: "save-button", on: { click: _vm.submitForm } },
              [_vm._v("\n        Save\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-page" }, [
        _c(
          "div",
          {
            staticClass: "icon-setup-view",
            on: { click: _vm.openConfiguration }
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/new-form-ui/setup.svg") }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-page-content input-field" }, [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("h6", { staticClass: "card-title-text" }, [
                _vm._v("View Information")
              ]),
              _vm._v(" "),
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.title.$error } },
                [
                  _c("label", [
                    _vm._v("Title "),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: { placeholder: "Enter title here" },
                    model: {
                      value: _vm.dataSetup.title,
                      callback: function($$v) {
                        _vm.$set(_vm.dataSetup, "title", $$v)
                      },
                      expression: "dataSetup.title"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isExternalApi
                ? _c(
                    "b-form",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.sheet_name.$error
                      }
                    },
                    [
                      _c("label", [_vm._v("Sheet Name")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: { placeholder: "Enter sheet name here" },
                        model: {
                          value: _vm.dataSetup.sheet_name,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "sheet_name", $$v)
                          },
                          expression: "dataSetup.sheet_name"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.dataSetup.is_use_advance_report || _vm.isDatasetSource
                ? _c(
                    "b-form",
                    [
                      _c("label", [_vm._v("Format File")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.isDatasetSource
                            ? _vm.listFormatFileAdvanceReport
                            : _vm.listFormatFile,
                          disabled: _vm.isDatasetSource,
                          placeholder: "Select Format File"
                        },
                        model: {
                          value: _vm.$v.dataSetup.format_file.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.dataSetup.format_file,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.dataSetup.format_file.$model"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isExternalApi
            ? _c(
                "div",
                { staticClass: "section" },
                [
                  _c("h6", { staticClass: "card-title-text mb-2" }, [
                    _vm._v("Sheet")
                  ]),
                  _vm._v(" "),
                  !_vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "wrap-column" },
                        [
                          _c(
                            "draggable",
                            {
                              staticClass: "d-flex align-items-center",
                              attrs: {
                                options: {
                                  animation: 300
                                }
                              },
                              model: {
                                value: _vm.dataSetup.sheet,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "sheet", $$v)
                                },
                                expression: "dataSetup.sheet"
                              }
                            },
                            _vm._l(_vm.dataSetup.sheet, function(data, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "column-block" },
                                [
                                  _c("div", { staticClass: "column-name" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(data.sheet_name) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "edit-or-delete" }, [
                                    _c("div", { staticClass: "button" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "edit",
                                          on: {
                                            click: function($event) {
                                              _vm.openConfigSheet(data, index)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-pencil-square-o"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tooltip-component"
                                            },
                                            [_vm._v("Edit sheet")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "delete",
                                          on: {
                                            click: function($event) {
                                              _vm.deleteSheet(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-trash"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tooltip-component"
                                            },
                                            [_vm._v("Delete sheet")]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            })
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn-add-column",
                              on: {
                                click: function($event) {
                                  _vm.openConfigSheet(null, null)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "m__r--5",
                                attrs: {
                                  src: require("@/assets/icon/add.png"),
                                  height: "15",
                                  width: "15"
                                }
                              }),
                              _vm._v("\n            Add Sheet\n          ")
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoading ? _c("j-skeleton-sheet") : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isExternalApi
            ? _c(
                "div",
                { staticClass: "section" },
                [
                  _c("h6", { staticClass: "card-title-text mb-2" }, [
                    _vm._v("Column")
                  ]),
                  _vm._v(" "),
                  !_vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "wrap-column" },
                        [
                          _c(
                            "draggable",
                            {
                              staticClass: "d-flex align-items-center",
                              attrs: {
                                options: {
                                  animation: 300
                                }
                              },
                              model: {
                                value: _vm.dataSetup.column,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "column", $$v)
                                },
                                expression: "dataSetup.column"
                              }
                            },
                            _vm._l(_vm.dataSetup.column, function(data, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "column-block" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/icon/column-type/" +
                                        _vm.setIconType(data.type) +
                                        ".svg"),
                                      alt: data.name + "-block"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "separator" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "column-name" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(data.name) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "edit-or-delete" }, [
                                    _c("div", { staticClass: "button" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "edit",
                                          on: {
                                            click: function($event) {
                                              _vm.openConfigColumn(data, index)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-pencil-square-o"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tooltip-component"
                                            },
                                            [_vm._v("Edit column")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "delete",
                                          on: {
                                            click: function($event) {
                                              _vm.deleteColumn(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-trash"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tooltip-component"
                                            },
                                            [_vm._v("Delete column")]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            })
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn-add-column",
                              on: {
                                click: function($event) {
                                  _vm.openConfigColumn(null, null)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "m__r--5",
                                attrs: {
                                  src: require("@/assets/icon/add.png"),
                                  height: "15",
                                  width: "15"
                                }
                              }),
                              _vm._v("\n            Add Column\n          ")
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoading ? _c("j-skeleton-sheet") : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.advanceReportSetting && !_vm.isExternalApi && !_vm.isDatasetSource
        ? _c("div", { staticClass: "card-page m__t--25" }, [
            _c(
              "div",
              { staticClass: "card-page-content input-field" },
              [
                _c("h6", { staticClass: "card-title-text" }, [
                  _vm._v("Advance Report")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-toggle-config" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between"
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("j-toggle", {
                        staticClass: "fix-position-toggle",
                        model: {
                          value: _vm.dataSetup.is_use_advance_report,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.dataSetup,
                              "is_use_advance_report",
                              $$v
                            )
                          },
                          expression: "dataSetup.is_use_advance_report"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.dataSetup.is_use_advance_report
                  ? _c(
                      "b-form",
                      { staticClass: "mt-3" },
                      [
                        _c("label", [_vm._v("Format File")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            disabled: true,
                            options: _vm.listFormatFileAdvanceReport,
                            "error-required": false,
                            placeholder: "Select Format File"
                          },
                          model: {
                            value: _vm.$v.dataSetup.format_file.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.format_file,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.format_file.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfiguration
        ? _c("export-view-configuration", {
            attrs: {
              id: _vm.idConfiguration,
              "data-config": _vm.dataSetup,
              "list-function": _vm.listFunction,
              variables: _vm.variableOptions,
              "variable-options": _vm.variableOptionsClass,
              "is-have-configuration": _vm.isHaveConfiguration
            },
            on: {
              "delete-view": _vm.deleteView,
              "close-configuration": function($event) {
                _vm.toggleConfiguration(false)
              },
              submit: _vm.submitConfig
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenSheetConfiguration
        ? _c("sheet-configuration", {
            attrs: {
              id: _vm.idConfigurationSheet,
              "field-detail": _vm.selectedSheet,
              "first-sheet": _vm.isFirstSheet,
              "variable-columns": _vm.variableOptionsSheet,
              "variable-custom-columns": _vm.variableCustomOptions,
              "is-dataset-source": _vm.isDatasetSource
            },
            on: {
              "delete-sheet": _vm.deleteSheet,
              "close-configuration": function($event) {
                _vm.toggleSheetConfiguration(false)
              },
              "submit-configuration": _vm.submitSheet
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigColumn
        ? _c("column-configuration", {
            attrs: {
              id: _vm.idConfigColumn,
              "field-detail": _vm.selectedColumn,
              "select-variable": _vm.variableOptionsColumn,
              type: "export"
            },
            on: {
              "delete-configuration": _vm.deleteColumn,
              "close-configuration": function($event) {
                _vm.toggleConfigurationColumn(false)
              },
              "submit-configuration": _vm.submitColumn
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalFieldLibrary
        ? _c("modal-field-library", {
            on: { "close-modal": _vm.closeModalFieldLibrary }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalExternalApi",
          staticClass: "modal-external-api",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [_vm.showModalExternalUrl ? _c("modal-external-api-field") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h4", { staticClass: "title-config" }, [_vm._v("Advance Export")]),
      _vm._v(" "),
      _c("p", { staticClass: "description mb-0" }, [
        _vm._v(
          "\n              Support for exporting big data to table Data Manager and including monitoring reports\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-371f47c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371f47c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jExportView.vue
// module id = null
// module chunks = 